import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

try {
  const intendedPath = sessionStorage.getItem("meta_intended_path");
  if (intendedPath) {
    sessionStorage.removeItem("meta_intended_path");
    window.history.replaceState(null, "", intendedPath);
  }
} catch (e) {}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
